(function () {
  'use strict';

  /* @ngdoc object
   * @name account.feedback
   * @description
   *
   */
  angular
    .module('account.feedback', [
      'ui.router'
    ]);
}());
